import React, { useState } from 'react'

const IntershipSalesforce = () => {
    const [activeTab, setActiveTab] = useState('basics'); // Default tab

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <section id="devops">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="text-purple">6-Month Sales Force Roadmap </h2>
                        <p className="fw-medium">(From Scratch to Expert)</p>
                    </div>
                </div>
                <div className="row my-5 devcontaint">
                    <div className="col-md-3 col-12">
                        <div className="left-side h-100 flex-md-row flex-column">
                            <ul className="d-md-block d-flex">
                                {/* Tab Buttons */}
                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'basics' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('basics')}
                                >
                                    <div className={`fs-1 image-section type2    ${activeTab === 'basics' ? '' : '  '}`}>
                                        1
                                    </div>
                                    <div className={`text-section d-md-inline ${activeTab === 'basics' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold" >Basics</h6>
                                    </div>
                                </li>

                                <li
                                    role='button' className={`d-flex flex-md-row flex-column ${activeTab === 'react' ? 'active ' : ''}`}
                                    onClick={() => handleTabClick('react')}
                                >
                                    <div className="image-section type2 fs-2">
                                        2
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'react' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Advanced Features</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'node-js' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('node-js')}
                                >
                                    <div className="image-section type2 fs-1">
                                        3
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'node-js' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Development and Integration</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'MongoDB' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('MongoDB')}
                                >
                                    <div className="image-section type2 fs-1">
                                        4
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'MongoDB' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Certification Preparation</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'full-stack' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('full-stack')}
                                >
                                    <div className="image-section type2 fs-1 ">
                                        5
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'full-stack' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Interview Preparation</h6>
                                    </div>
                                </li>

                                <li role='button'
                                    className={`d-flex flex-md-row flex-column ${activeTab === 'interview-preparation' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('interview-preparation')}
                                >
                                    <div className="image-section type2 fs-1" >
                                        6
                                    </div>
                                    <div className={`text-section  d-md-inline ${activeTab === 'interview-preparation' ? 'text-danger d-inline' : 'd-none'}`}>
                                        <h6 className="fw-bold">Final Review</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-9 col-12">
                        <div className="right-side">
                            {activeTab === 'basics' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Introduction to Salesforce and Basic Concepts</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 1: Introduction to Salesforce Platform
                                    </strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 1-2: Introduction to Salesforce – </strong> Overview of CRM, Cloud-based solutions,
                                            Salesforce Architecture (multi-tenant, metadata-driven).
                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 3-4: Overview of Salesforce Products  – </strong>
                                            Sales Cloud, Service Cloud, Marketing
                                            Cloud, AppExchange.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 5-6: Navigating Salesforce Interface – </strong> Salesforce Setup, App Launcher,
                                            Standard Tabs, Customizing Tabs.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 7: Test Day:</strong> Basic Salesforce Quiz.

                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 2: Salesforce Data Model
                                    </strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 8-9: Introduction to Salesforce Objects – </strong>
                                            Standard and Custom Objects.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 10-11:  Relationships in Salesforce – </strong> Lookup, Master-Detail, Many-to-Many.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 12-13: Fields & Record Types – </strong>
                                            Field-level security, formula fields, record
                                            types, and page layouts.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 14: Test Day – </strong>Salesforce Objects, Fields, and Relationships
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 3: Salesforce Security Model
                                    </strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 15-16:  User Management – </strong> Users, Profiles, Permission Sets.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 17-18: Role Hierarchy and Sharing Rules – </strong>  Public Groups, Role-Based Sharing,
                                            Sharing Rules.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 19-20:  Field-Level Security and Data Access – </strong> Field visibility, encryption,
                                            sharing settings.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 21: Test Day – </strong> Security and Sharing Model quiz.

                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 4: Basic Automation and Reports</strong>
                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 22-23: Introduction to Workflow Rules and Process Builder – </strong> Automating
                                            tasks like email alerts and field updates.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 24-25: Introduction to Flow Builder – </strong> Building simple flows and automating
                                            business processes.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 26-27: Reports and Dashboards – </strong>
                                            Creating custom reports, summary reports,
                                            and dashboards.

                                        </li>
                                        <li className="fs-6">
                                            <strong>Day 28: Test Day – </strong>Basic Automation and Reports quiz
                                        </li>
                                    </ul>
                                </div>



                            )}
                            {activeTab === 'react' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3"> Advanced Salesforce Features
                                    </h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 5:Advanced Automation and Process Management</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 29-30: Advanced Workflow and Process Builder – </strong>
                                            Complex automation
                                            scenarios, Scheduled Flows.

                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 31-32:  Approval Processes – </strong>Creating approval processes for record
                                            management.

                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 33-34: Using Flow for Automation – </strong>
                                            Advanced Flow techniques.

                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 35: Test Day – </strong>
                                            Automation and Process Builder practical test
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 6: Advanced Reporting and Dashboards</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 36-37: Advanced Reporting – </strong>
                                            Custom Report Types, Cross Filters, Bucket
                                            Fields.

                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 38-39 : Dashboard Creation – </strong>
                                            Building dynamic and interactive dashboards.

                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 40-41: Data Visualization – </strong>
                                            Advanced features in dashboards, dynamic charts,
                                            and graphs
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 42: Test Day – </strong>
                                            Reporting and Dashboards practical test.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 7: Introduction to Apex and Developer Tools</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 43-44: Introduction to Apex – </strong>
                                            Apex Classes, Variables, Data Types, and Syntax.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 45-46: Apex Triggers – </strong>
                                            Writing triggers to automate data handling.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 47-48: Salesforce Developer Console – </strong>
                                            Debugging, Query Editor, and Logs.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 49-50: SOQL (Salesforce Object Query Language) – </strong>
                                            Writing and executing queries.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 51: Test Day – </strong>
                                            Apex and Developer Console basics.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 8: Lightning Components and Advanced Apex</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 52-53: Introduction to Lightning Components – </strong>
                                            Component-based architecture.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 54-55: Advanced Apex – </strong>
                                            Batch Apex, Future Methods, Queueable Apex.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 56-57: Debugging Apex – </strong>
                                            Using Developer Console, Debug Logs, and testing.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 58-59: Advanced Topics in Apex – </strong>
                                            Asynchronous Apex, Platform Events.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 60: Test Day – </strong>
                                            Lightning Components and Advanced Apex quiz.
                                        </li>
                                    </ul>
                                </div>


                            )}
                            {activeTab === 'node-js' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Salesforce Development and Integration</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 9: Introduction to Integrations</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 61-62: Introduction to Salesforce Integrations – </strong>
                                            Overview of Integration Options (APIs, REST, SOAP).
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 63-64: Using REST API – </strong>
                                            Sending and receiving data with REST API.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 65-66: Using SOAP API – </strong>
                                            Setting up and calling SOAP APIs.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 67: Test Day – </strong>
                                            Integration Basics (REST/SOAP).
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 10: Working with External Systems and Data</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 68-69: Integration with External Data – </strong>
                                            Connecting Salesforce to external databases using External Objects.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 70-71: Using Data Loader – </strong>
                                            Importing and exporting data in Salesforce.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 72-73: External Services – </strong>
                                            Setting up an external service in Salesforce.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 74: Test Day – </strong>
                                            Data Integration quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 11: Advanced Apex and Asynchronous Programming</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 75-76: Batch Apex – </strong>
                                            Creating batch jobs for large data volumes.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 77-78: Future Methods and Queueable Apex – </strong>
                                            Performing asynchronous operations.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 79-80: Scheduled Apex – </strong>
                                            Automating tasks at scheduled intervals.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 81: Test Day – </strong>
                                            Advanced Apex techniques quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 12: Security, Testing & Best Practices</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 82-83: Security Best Practices in Salesforce – </strong>
                                            Data security, Shield Platform Encryption.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 84-85: Testing in Apex – </strong>
                                            Writing test classes, coverage, and assertions.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 86-87: Debugging and Error Handling – </strong>
                                            Best practices for error handling and debugging.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 88: Test Day – </strong>
                                            Security, Testing, and Best Practices quiz.
                                        </li>
                                    </ul>

                                </div>

                            )}



                            {activeTab === 'MongoDB' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Salesforce Certification Preparation</h1>


                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 13: Preparing for Salesforce Admin Certification</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 89-91: Salesforce Admin Exam Overview – </strong>
                                            Key topics, Study strategies.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 92-93: Data Management – </strong>
                                            Data Import Wizard, Export, Backup.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 94-95: Security and Access – </strong>
                                            Profiles, Permission Sets, Sharing Rules.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 96: Test Day – </strong>
                                            Admin Certification Mock Test.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 14: Preparing for Salesforce Developer Certification</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 97-99: Developer Exam Overview – </strong>
                                            Key topics, Study strategies.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 100-101: Apex Fundamentals – </strong>
                                            Core concepts and trigger patterns.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 102-103: Lightning Components & Developer Console – </strong>
                                            Advanced usage.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 104: Test Day – </strong>
                                            Developer Certification Mock Test.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 15: Hands-on Project – Admin Focus</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 105-106: Build a Salesforce Application – </strong>
                                            Custom Objects, Automation.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 107-108: Security Configuration – </strong>
                                            Profiles, Permission Sets, Sharing Rules.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 109-110: Reports & Dashboards – </strong>
                                            Advanced reporting, dynamic dashboards.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 111: Test Day – </strong>
                                            Admin Project Submission and Review.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 16: Hands-on Project – Developer Focus</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 112-113: Build a Salesforce App – </strong>
                                            Apex, Visualforce, and Lightning Components.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 114-115: API Integration – </strong>
                                            Connecting to external systems.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 116-117: Debugging and Testing – </strong>
                                            Writing test classes and debugging techniques.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 118: Test Day – </strong>
                                            Developer Project Submission and Review.
                                        </li>
                                    </ul>
                                </div>

                            )}

                            {activeTab === 'full-stack' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Mock Tests, Interview Preparation, and Job Search</h1>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 17: Mock Interviews & Aptitude Practice</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 119-120: Mock Technical Interviews – </strong>
                                            Practice with typical Salesforce questions (Admin & Developer).
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 121-122: Coding Challenges and Problem Solving – </strong>
                                            Practice with Salesforce coding challenges.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 123-124: Soft Skills – </strong>
                                            Interview etiquette, communication skills, and job application strategies.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 125: Test Day – </strong>
                                            Mock Interview (Technical + HR).
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 18: Job Search Strategies & Salesforce Job Market</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 126-128: Job Opportunities in Salesforce – </strong>
                                            Admin, Developer, Consultant roles.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 129-130: Resume Building – </strong>
                                            Creating a Salesforce-specific resume.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 131-132: LinkedIn Optimization – </strong>
                                            Profile tips for landing Salesforce roles.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 133: Test Day – </strong>
                                            Job Search Strategy Quiz.
                                        </li>
                                    </ul>

                                </div>

                            )}

                            {activeTab === 'interview-preparation' && (
                                <div className="container mt-4">
                                    <h1 className="fw-bold fs-3 text-danger mb-3">Final Review, Certification, and Deployment</h1>
                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 19: Final Review and Certification Prep</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 134-136: Review Core Salesforce Concepts – </strong>
                                            Exam preparation strategies.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 137-138: Certification Exam Practice – </strong>
                                            Mock exam for both Admin and Developer certifications.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 139-140: Final Hands-on Practice – </strong>
                                            Resolve complex scenarios using Admin and Developer tools.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 141: Test Day – </strong>
                                            Final Certification Exam Prep Quiz.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 20: Certification & Real-World Application</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 142-144: Schedule and Take Salesforce Admin or Developer Exam – </strong>
                                            Register and attempt the certification exam.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 145-146: Review Certification Exam Results – </strong>
                                            Focus on weak areas.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 147-148: Real-World Applications – </strong>
                                            Deploying a Salesforce solution in real-world scenarios.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 149-150: Apply for Jobs – </strong>
                                            Apply to Salesforce job opportunities using your resume.
                                        </li>
                                    </ul>

                                    <strong className="fw-bold fs-5 text-danger mb-2">Week 21: Final Review & Job Search</strong>

                                    <ul className="ms-4">
                                        <li>
                                            <strong>Day 151-153: Reviewing Everything Learned – </strong>
                                            Recap of key skills.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 154-156: Job Applications and Interviews – </strong>
                                            Apply for jobs and prepare for interviews.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 157-159: Final Touch – </strong>
                                            Refining your LinkedIn, resume, and interview skills.
                                        </li>

                                        <li className="fs-6">
                                            <strong>Day 160: Test Day – </strong>
                                            Final Interview Mock Test.
                                        </li>
                                    </ul>
                                </div>

                            )}
                        </div>
                    </div>
                </div>


            </div >
        </section >
    )
}

export default IntershipSalesforce